import React from "react";
import styled from "styled-components";
const StylableVideo = React.forwardRef((props, ref) => {
    const { media, ...rest } = props;
    const isMuted = props.muted ?? props.autoPlay;
    const isLooped = props.loop ?? props.autoPlay;
    return (React.createElement("video", { ...rest, ref: ref, muted: isMuted, loop: isLooped, playsInline: props.autoPlay }, media.sources.map((source, index) => (React.createElement("source", { "data-testid": `source-${source.type}`, key: index, src: source.src, type: source.type })))));
});
StylableVideo.displayName = "StylableVideo";
StylableVideo.defaultProps = {
    "data-testid": "mediaHtml5Video",
};
export const MediaHtml5Video = styled(StylableVideo) `
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
//# sourceMappingURL=MediaHtml5Video.js.map